import { render, staticRenderFns } from "./BirthdayBanner.vue?vue&type=template&id=0a30563e&scoped=true"
import script from "./BirthdayBanner.vue?vue&type=script&lang=js"
export * from "./BirthdayBanner.vue?vue&type=script&lang=js"
import style0 from "./BirthdayBanner.vue?vue&type=style&index=0&id=0a30563e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30563e",
  null
  
)

export default component.exports